import { logErrorMessage } from '../../monitoring/log';

export const storageHelpers = {
    getItem<T>(key: string): T | null {
        try {
            const value = localStorage.getItem(key);
            return value ? (JSON.parse(value) as T) : null;
        } catch (error) {
            const errorMsg = 'Error parsing JSON from localStorage';
            this.removeItem(key);
            logErrorMessage(errorMsg, {
                key,
                error: JSON.stringify(error),
            });
            return null;
        }
    },

    setItem<T>(key: string, value: T): void {
        try {
            const jsonValue = JSON.stringify(value);
            localStorage.setItem(key, jsonValue);
        } catch (error) {
            const errorMsg = 'Error stringifying JSON for localStorage';
            this.removeItem(key);
            logErrorMessage(errorMsg, {
                key,
                value: JSON.stringify(value),
                error: JSON.stringify(error),
            });
        }
    },

    removeItem(key: string): void {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            const errorMsg = 'Error removing item from localStorage';
            logErrorMessage(errorMsg, {
                key,
                error: JSON.stringify(error),
            });
        }
    },

    getSessionItem<T>(key: string): T | null {
        try {
            const value = sessionStorage.getItem(key);
            return value ? (JSON.parse(value) as T) : null;
        } catch (error) {
            const errorMsg = 'Error parsing JSON from sessionStorage';
            this.removeSessionItem(key);
            logErrorMessage(errorMsg, {
                key,
                error: JSON.stringify(error),
            });
            return null;
        }
    },

    setSessionItem<T>(key: string, value: T): void {
        try {
            const jsonValue = JSON.stringify(value);
            sessionStorage.setItem(key, jsonValue);
        } catch (error) {
            const errorMsg = 'Error stringifying JSON for sessionStorage';
            this.removeSessionItem(key);
            logErrorMessage(errorMsg, {
                key,
                value: JSON.stringify(value),
                error: JSON.stringify(error),
            });
        }
    },

    removeSessionItem(key: string): void {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
            const errorMsg = 'Error removing item from sessionStorage';
            logErrorMessage(errorMsg, {
                key,
                error: JSON.stringify(error),
            });
        }
    },
};
